<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ded">
<p class="dedf"><a class="page" id="page.v"></a>To</p>
<p class="ded">David H. Wallace</p>
<p class="dedf">and</p>
<p class="dedf">the Memory of</p>
<p class="ded">Robert B. Laurin (1927–77)</p>
<p class="ded">Christian Gentlemen</p>
<p class="ded">and Scholars, Both</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-nicot04nu-0004.vue?3e8ec5e7